import { useContext } from 'react'
import { useQuery, useMutation, useQueryClient } from 'react-query'
import { apiGet, apiPatch } from 'api'
import AuthContext from 'context/auth-context'

const url = (municipalityId) => `admin/municipalities/${municipalityId}/analytic_configs`
const queryKey = (municipalityId) => ['admin-municipality-analytic-configs', municipalityId]

// Every config key this municipality's analytics read, with its value.
export function useAdminMunicipalityAnalyticConfigs({ municipalityId, options } = {}) {
  const token = useContext(AuthContext)
  return useQuery(queryKey(municipalityId), () => apiGet({ url: url(municipalityId), token }), {
    enabled: !!municipalityId,
    ...options
  })
}

// `configs` is `{ config_key: value }`; the response is the refreshed list.
export function useUpdateAdminMunicipalityAnalyticConfigs({ municipalityId, options } = {}) {
  const token = useContext(AuthContext)
  const queryClient = useQueryClient()

  return useMutation(
    (configs) =>
      apiPatch({ url: `${url(municipalityId)}/batch_update`, token, objectName: 'configs', params: configs }),
    {
      ...options,
      onSuccess: (data, variables) => {
        queryClient.setQueryData(queryKey(municipalityId), data)
        queryClient.invalidateQueries(['admin-analytic-config-keys'])
        if (options?.onSuccess) options.onSuccess(data, variables)
      }
    }
  )
}
